export const carbonOffsetFeeInputName = 'carbon_offset_fee'

export const defaultCarbonOffsetFee = 1
